import util from '@bmp-vue/core/api/util'

const controller = 'Monitoramento'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetHealthcheck: function () {
    return util.Axios.Get(controller + '/Healthcheck')
  },
})
